import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { absenceClient } from '../../../../core-module/services/absence/AbsenceClient';

const useAllDeployabilityOptionsQuery = () => {
  const queryResult = useQuery(
    ['getAllDeployabilityOptions'] as const,
    () => {
      return absenceClient.getAllDeployabilityOptions();
    },
    {
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    }
  );

  return useMemo(() => {
    if (queryResult.isLoading) {
      return {
        type: 'LOADING'
      };
    } else if (queryResult.isFetching) {
      return {
        type: 'FETCHING',
        data: queryResult.data
      };
    } else if (queryResult.error || !queryResult.data) {
      return {
        type: 'ERROR'
      };
    } else if (queryResult.data) {
      return {
        type: 'USABLE',
        data: queryResult.data,
        refetch: queryResult.refetch
      };
    } else {
      return { type: 'UNKNOWN' };
    }
  }, [
    queryResult.data,
    queryResult.error,
    queryResult.isFetching,
    queryResult.isLoading,
    queryResult.refetch
  ]);
};

export { useAllDeployabilityOptionsQuery };
